import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import InformationForm from '../modules/InformationForm';

class NewInformationPage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { showOnHomepage: true, headerImageLarge: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nová užitečná informace</h1>
          <InformationForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewInformationPage;



// WEBPACK FOOTER //
// ./src/pages/NewInformationPage.js